import { gql } from '@apollo/client/core'

import { PAGE_INFO_ATTRIBUTES } from './fragments'

export const PAGINATED_PRODUCT_INSTANCE_QUERY = gql`
  query productInstances(
    $id: ID
    $status: ProductInstanceStatusEnum
    $query: String
    $first: Int
    $last: Int
    $offset: Int
    $after: String
    $before: String
  ) {
    productInstances: productInstancesPaginated(
      id: $id
      status: $status
      query: $query
      first: $first
      last: $last
      offset: $offset
      after: $after
      before: $before
    ) {
      pageInfo {
        ...pageInfoAttributes
      }
      totalCount
      maxPageSize
      pageIndex
      nodes {
        id
        name
        status
        serialNumber
        productInstanceBookings {
          id
          startDate
          returnDate
          bookingType
          project {
            id
            name
          }
        }
      }
    }
  }
  ${PAGE_INFO_ATTRIBUTES}
`

export const CREATE_PRODUCT_INSTANCE_BOOKING = gql`
  mutation createProductInstanceBooking($input: CreateProductInstanceBookingInput!) {
    createProductInstanceBooking(input: $input) {
      productInstanceBooking {
        id
        name
        startDate
        returnDate
        bookingType
        serialNumber
      }
      errors {
        path
        message
      }
    }
  }
`
export const CREATE_CUSTOMER_PRODUCT_INSTANCE = gql`
  mutation createCustomerProductInstance($input: CreateCustomerProductInstanceInput!) {
    createCustomerProductInstance(input: $input) {
      productInstance {
        id
        name
        status
        serialNumber
      }
      errors {
        path
        message
      }
    }
  }
`

export const UPDATE_CUSTOMER_PRODUCT_INSTANCE = gql`
  mutation updateCustomerProductInstance($input: UpdateCustomerProductInstanceInput!) {
    updateCustomerProductInstance(input: $input) {
      productInstance {
        id
        status
        serialNumber
      }
    }
  }
`
